<!--
 * @Author: lidan
 * @Date: 2020-10-27 15:21:42
 * @LastEditTime: 2020-11-20 09:33:02
 * @LastEditors: lidan
 * @Description: 服务评价预览弹窗组件
 * @FilePath: \e6-module-order-waybill-process\src\e6-module-order-waybill-process\views\rules\serviceComment\components\serviceCommentPreview.vue
-->
<template>
  <div class="preview">
    <div class="top">
      <img src="../assets/imgs/top.jpg" width="100%" height="64px" />
    </div>
    <div class="main">
      <section class="content">
        <div
          class="content-item"
          v-show="editFormData.evaluateNameStatus === 1"
        >
          <span style="color:red">
            {{ editFormData.evaluateNameRequired === 1 ? "*" : "" }}
          </span>
          <span
            >您的姓名({{
              editFormData.evaluateNameRequired === 1 ? "必填" : "选填"
            }})</span
          >
          <span class="right placeholder" @click="nameTips">
            请输入姓名
          </span>
        </div>
        <div class="content-item" v-show="editFormData.customAreaStatus === 1">
          <span style="color:red">
            {{ editFormData.customAreaStatus === 1 ? "*" : "" }}
          </span>
          <span
            >所属门店({{
              editFormData.customAreaStatus === 1 ? "必填" : "选填"
            }})</span
          >
          <span class="right placeholder" @click="tips">
            请选择
            <i class="e6-icon-arrow-r_line"></i>
          </span>
        </div>
        <div
          class="content-item"
          v-show="editFormData.evaluateOccupationStatus === 1"
        >
          <span style="color:red">
            {{ editFormData.evaluateOccupationRequired === 1 ? "*" : "" }}
          </span>
          <span
            >您的职位({{
              editFormData.evaluateOccupationRequired === 1 ? "必填" : "选填"
            }})</span
          >
          <span class="right placeholder" @click="tips">
            请选择
            <i class="e6-icon-arrow-r_line"></i>
          </span>
        </div>
      </section>
      <section class="comment">
        <p class="title">服务评价项</p>
        <div
          class="comment-item"
          v-for="(item, index) in editFormData.evaluateGradeSettingPOS"
          :key="index"
        >
          <div class="comment-title">
            {{ index + 1 }}.{{ item.evaluateItem }}
          </div>
          <div class="comment-star">
            <el-rate v-model="item.starValue" show-text :texts="starTexts">
            </el-rate>
          </div>
          <div class="comment-text" v-show="item.evaluateRemarkRequired === 1">
            <el-input
              type="textarea"
              maxlength="200"
              :rows="4"
              show-word-limit
              :placeholder="
                item.evaluateRemarkRequired === 1 &&
                item.starValue <= item.evaluateLessStar
                  ? '请输入备注信息(必填)'
                  : '请输入备注信息(选填)'
              "
              v-model="item.textarea"
            >
            </el-input>
          </div>
        </div>
      </section>
      <section
        class="comment advise"
        v-show="editFormData.evaluateAdviseStatus === 1"
      >
        <p class="title">
          <span style="color:red">
            {{ editFormData.evaluateAdviseRequired === 1 ? "*" : "" }}
          </span>
          意见以及建议
        </p>
        <el-input
          type="textarea"
          maxlength="200"
          :rows="4"
          show-word-limit
          placeholder="请输入意见或建议"
          v-model="adviseTextarea"
        >
        </el-input>
      </section>
      <section class="comment" v-show="editFormData.evaluatePhotoStatus === 1">
        <p class="title">
          <span style="color:red">
            {{ editFormData.evaluatePhotoRequired === 1 ? "*" : "" }}
          </span>
          上传照片（最多5张）
        </p>
        <div class="img-upload">
          <div
            class="imgs"
            v-for="(img, index) in fileList"
            :key="'img' + index"
          >
            <el-image :src="img.url" :preview-src-list="srcList"></el-image>
            <i
              class="e6-icon-delete_fill delete-img"
              @click="handleRemove(index)"
            ></i>
          </div>
          <el-upload
            class="upload"
            v-show="fileList.length < 5"
            action="#"
            list-type="picture-card"
            :auto-upload="false"
            :on-change="handleChange"
            :show-file-list="false"
            :file-list="fileList"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
      </section>
      <el-button type="primary" @click="handleSubmitTips">提交</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "serviceCommentPreview",
  props: ["editFormData"],
  data() {
    return {
      radio: "",
      starTexts: ["非常不满意", "不满意", "一般", "满意", "非常满意"],
      commentText: [],
      adviseTextarea: "",
      ruleForm: {},
      rules: {},
      fileList: [],
      srcList: [],
      maxLength: 5,
      hasUploadError: false
    };
  },
  mounted() {
    this.radio = this.editFormData.evaluateOccupationPOS[0].id;
    for (let i = 0; i < this.editFormData.evaluateGradeSettingPOS.length; i++) {
      this.commentText.push({
        starValue: "",
        textarea: ""
      });
    }
  },
  methods: {
    nameTips() {
      this.$message("当前是预览状态，无法填写");
    },
    tips() {
      this.$message("当前是预览状态，无法选择");
    },
    handleSubmitTips() {
      this.$message("当前是预览状态，无法提交");
    },
    //删除照片按钮
    handleRemove(index) {
      this.fileList.splice(index, 1);
      this.srcList.splice(index, 1);
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
      this.srcList.push(file.url);
    }
  }
};
</script>

<style lang="scss" scoped>
.preview {
  height: 667px;
  background-color: #f3f4f6;
  color: #020202;
  .main {
    height: 603px;
    overflow: auto;
    div {
      background: #fff;
    }
    .content {
      background: #f3f4f6;
      .content-item {
        padding: 16px 10px;
        margin-bottom: 1px;
      }
    }
    .comment {
      .title {
        padding: 15px 0 10px 10px;
      }
      .comment-item {
        padding: 18px 10px;
      }
      .comment-star {
        padding: 15px 0 20px 15px;
        /deep/ .el-rate__text {
          font-size: 12px;
        }
      }

      .img-upload {
        padding: 19px 20px 15px 10px;
        .imgs {
          display: inline-block;
          width: 105px;
          height: 105px;
          position: relative;
          margin-right: 10px;
          margin-bottom: 10px;
          .delete-img {
            position: absolute;
            top: -4px;
            right: -5px;
            color: red;
            cursor: pointer;
          }
          .el-image {
            width: 105px;
            height: 105px;
            border-radius: 3px;
          }
        }
        .upload {
          display: inline-block;
          vertical-align: top;
        }
        /deep/ {
          .el-upload.el-upload--picture-card {
            width: 105px;
            height: 105px;
            line-height: 105px;
            border: 0;
            background: #f3f4f5;
          }
        }
      }
    }
    //右边展示内容
    .right {
      display: inline-block;
      float: right;
      right: 10px;
    }
    .right-radio {
      width: 165px;
      .el-radio {
        margin-bottom: 15px;
      }
    }
    //输入框下拉框提示语
    .placeholder {
      color: #9e9e9e;
    }
    //右边下拉小箭头
    .e6-icon-arrow-r_line {
      color: #929292;
    }

    .advise {
      /deep/textarea.el-textarea__inner {
        resize: none;
        border: 0;
      }
    }

    /deep/ button.el-button.el-button--primary.el-button--mini {
      width: calc(100% - 20px);
      height: 50px;
      font-size: 16px;
      background: #0389f9;
      margin: 50px 10px;
    }
  }
  /deep/textarea.el-textarea__inner {
    resize: none;
  }
  .main::-webkit-scrollbar {
    width: 0px;
  }

  .main::-o-scrollbar {
    width: 0px;
  }
  .main::-moz-scrollbar {
    width: 0px;
  }
  /*兼容IE*/
  .main {
    -ms-scroll-chaining: chained;
    -ms-overflow-style: none;
    -ms-content-zooming: zoom;
    -ms-scroll-rails: none;
    -ms-content-zoom-limit-min: 100%;
    -ms-content-zoom-limit-max: 500%;
    -ms-scroll-snap-type: proximity;
    -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
    -ms-overflow-style: none;
    overflow: auto;
  }
}
</style>
